import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import Login from './Login';
import Signup from './Signup';
import { useLocation } from 'react-router-dom';
import ForgotPassword from './ForgotPassword';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    if (location.pathname === '/forgot-password') {
      return <ForgotPassword />;
    }
    if (location.pathname === '/signup') {
      return <Signup />;
    }
    return <Login />;
  }

  return children;
};

export default ProtectedRoute;